import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { LocationQuery } from 'vue-router';
import { Team } from './team.interface';

export const TEAM_INCLUDES = [
   'tenant',
   'tenantCount',
   'users',
   'usersCount',
   'cluster',
   'clusterCount',
   'city',
   'city.country',
   'cityCount',
   'tenant',
   'mailboxes',
];

export class TeamService {
   async getTeams(query?: LocationQuery): Promise<ApiResource<Team>> {
      const response = await http.get<ApiResource<Team>>(`/teams`, { params: { ...query, include: 'tenant' } });
      return response.data;
   }
   async getTeam(teamId: number, query?: LocationQuery): Promise<Team> {
      const response = await http.get<Team>(`/teams/${teamId}`, { params: { ...query } });
      return response.data;
   }
   async postTeam(team: Team): Promise<Team> {
      const response = await http.post<Team>(`/teams`, team);
      return response.data;
   }
   async putTeam(teamId: number, team: Team, query?: LocationQuery): Promise<Team> {
      const response = await http.put<Team>(`/teams/${teamId}`, team, { params: { ...query } });
      return response.data;
   }
   async deleteTeam(teamId: number): Promise<void> {
      const response = await http.delete(`/teams/${teamId}`);
      return response.data;
   }
}
